<script setup lang="ts">
const props = defineProps({
  value: {
    type: Boolean,
    default: false
  },
  title: {
    type: String
  },
  desc: {
    type: String
  },
  width: {
    type: String,
    default: '300'
  }
});
const { title, desc, width } = toRefs(props);
const emits = defineEmits(['update:value', 'ok']);

const handleCancel = () => {
  emits('update:value', false);
};
const handeleOk = () => {
  // emits('update:value',false);
  emits('ok');
};
</script>

<template>
  <div>
    <CsdDialog :showDialog="value" rounded="10">
      <div
        class="main"
        bg-white
        p-20px
        :style="{
          width: `${width}px`
        }"
      >
        <h4 v-if="title" h-30px text-16>{{ title }}</h4>
        <div v-if="desc" color="#999" flex-1 mb-20px text-13>{{ desc }}</div>
        <div h-30px w-full relative>
          <div absolute r-0 text-13>
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handeleOk">确定</el-button>
          </div>
        </div>
      </div>
    </CsdDialog>
  </div>
</template>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: start;
}
</style>
